// @flow
export const TypeTreeWellObj = {
    WEB_CONFIG:'web_config',
    
    UOP: 'uop',

    OP_UNITS: 'opunits',
    OIL_FIELDS: 'oilfields',
    WELLS: 'wells',
    FILES: 'files',
    REVISIONS: 'revisions',

    OP_UNIT: 'opunit',
    OIL_FIELD: 'oilfield',
    WELL: 'well',
    FILE: 'file',
    REVISION: 'revision',

    CARD_OPTIONS: 'cardoptions'
}
